import { makeAutoObservable, runInAction } from 'mobx'
import { searchCD } from '~/services/CDVerify'

class State {
  cd: CDResult | undefined
  loading: boolean = false
  error = false
  query = ''
  g_response = ''
  requireCaptcha: boolean | undefined
  constructor() {
    makeAutoObservable(this)
  }
  search = async () => {

    runInAction(() => {
      this.error = false
      this.loading = true
      this.requireCaptcha = this.g_response ? false : true
    })

    if (this.query && this.g_response) {

      try {
        const result = await searchCD({ seri_number: this.query, human_key: this.g_response })
        if (result?._id) {
          runInAction(() => {
            this.cd = result
          })
        } else {
          throw Error
        }
      } catch (ex) {
        runInAction(() => {
          this.error = true
          this.g_response = ''
          this.requireCaptcha = false
        })
      }
    }

    runInAction(() => {
      this.loading = false
    })

  }

  reset = async () => {
    runInAction(() => {
      this.cd = undefined
      this.g_response = ''
      this.requireCaptcha = undefined
      this.loading = false
      this.query = ''
      this.error = false
    })

  }

}

const state = new State
export default state